import { formatUnitPrice } from "services/api/pricing/consts";
import { PricingOtherValue } from "services/api/pricing/types";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

/** Ista vrijednost znači različitu stvar ovisno o vrsti — novac, postotak ili dani. */
const formatValue = (item: PricingOtherValue): string => {
  switch (item.valueKind) {
    case "Money":
      return formatUnitPrice.format(item.value);
    case "Percent":
      return `${item.value.toFixed(2).replace(".", ",")} %`;
    case "Days":
      return `${item.value.toFixed(0)} dana`;
    default:
      return item.value.toFixed(0);
  }
};

export const OTHER_VALUE_COLUMNS: Column[] = [
  {
    title: "Vrijednost",
    field: "name",
    sortable: true,
    type: ColumnTypes.custom,
    render: (row: PricingOtherValue) => (
      <div>
        <p className="text-slate-700">{row.name}</p>
        <p className="text-xs text-slate-400 font-mono">{row.code}</p>
      </div>
    ),
  },
  {
    title: "Iznos",
    field: "value",
    sortable: true,
    type: ColumnTypes.custom,
    render: (row: PricingOtherValue) => (
      <span className="font-semibold text-slate-700 whitespace-nowrap">
        {formatValue(row)}
      </span>
    ),
  },
];
